{
  "title": "如何評分並正式送出",
  "description": "依評分規準逐項評分，儲存草稿或正式送出分數。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，分數會被鎖定並計入該作品的評審進度，畫面切換為唯讀的覆核模式。",
  "roleNote": "評審",
  "prerequisites": ["已登入評審帳號", "該作品已指派給您，且未被利益衝突排除"],
  "pathLabel": "評審工作區 → 指派清單 → 評分頁",
  "steps": [
    {
      "title": "1. 依評分規準逐項評分",
      "description": "每個評分項目都有主辦方設定的允許範圍；輸入超出範圍的分數，送出前會被擋下並具名指出是哪一項超出範圍。所有評分項目都必須逐一填寫，不能留空。"
    },
    {
      "title": "2. 填寫評語",
      "description": "評分表分開提供兩個欄位：「個人評審備註」僅供您本人參考，絕不會顯示給主辦方；「審查意見」則是主辦方可以看到的評論。若該場競賽開啟「審查意見必填」設定，未填寫審查意見會無法正式送出。"
    },
    {
      "title": "3. 儲存草稿",
      "description": "尚未確定的評分可先儲存草稿，之後可以回來繼續修改，不會被視為正式送出。停止輸入約 1.5 秒後系統會自動儲存草稿，狀態列會顯示「草稿 · 已儲存於 …」；只會儲存您填寫過的評分項目，沒填的不會被當成 0 分。快捷鍵：Ctrl/⌘+S 儲存草稿、Ctrl/⌘+Enter 送出、Alt+←/→ 上一件／下一件。"
    },
    {
      "title": "4. 正式送出",
      "description": "所有評分項目都填寫完成前，「正式送出」按鈕會維持 disabled 狀態無法點擊。點擊「正式送出」後會先跳出確認對話框，列出總分與各項目分數供最後核對（若「個人評審備註」仍空白會額外顯示提醒，但不會擋下送出）；在對話框中再次確認後才會真正送出。送出後分數立即鎖定，畫面切換為唯讀的覆核模式。"
    }
  ],
  "afterward": [
    "畫面顯示明確的送出成功狀態",
    "分數進入鎖定狀態，您本人無法自行再修改",
    "評分頁提供前往下一件待處理作品的連結"
  ],
  "nextSteps": "若後續發現分數有誤，請聯絡該場競賽的主辦方；具權限的主辦方可以在投稿詳情頁對已鎖定的分數點擊「重新開放」並填寫理由，讓您重新修改。",
  "faq": [
    {
      "q": "送出時顯示分數超出範圍怎麼辦？",
      "a": "畫面會具名指出哪一個評分項目超出允許範圍，請依該項目的說明調整分數後再送出。"
    },
    {
      "q": "可以送出還沒填完的評分表嗎？",
      "a": "不行。所有評分項目都填寫完成前，「正式送出」按鈕會維持 disabled 狀態，系統會直接擋下未完成的送出；請依評分表右上角的完成度提示逐項補齊。"
    },
    {
      "q": "送出後才發現評錯了怎麼辦？",
      "a": "評審本人無法自行修改已送出的分數。請聯絡主辦方，具權限的主辦方可以直接在投稿詳情頁對該筆分數點擊「重新開放」並填寫理由，不需要再另外向平台管理端申請。"
    }
  ]
}
